import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonService } from 'wire-frame';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class PatientRegistrationService {

  private apiUrl: string;

  constructor(private http: HttpClient, private common: CommonService, private apiService: ApiService) { 
    this.apiUrl = this.apiService.getBaseUrl();
  }

  private getAuthHeaders() {
    const token = localStorage.getItem('jwtToken');
    return {
      headers: new HttpHeaders({
        'Authorization' : `Bearer ${token}`
      })
    }
  }

  checkDuplicatePatient(params: {
    full_name: string;
    contact_number?: string;
    old_card_number?: string;
    exclude_id?: number;
  }) {
    return this.http.get(
      this.apiUrl + '/patient/check-duplicate',
      {
        ...this.getAuthHeaders(),
        params
      }
    );
  }

  getDuplicatePatients() {
    return this.http.get(this.apiUrl + '/patient/duplicates', this.getAuthHeaders());
  }

  deactivatePatients(ids: number[]) {
    return this.http.post(this.apiUrl + '/patient/deactivate', { ids }, this.getAuthHeaders());
  }

  mergeDuplicateVisits(fromId: number, toId: number) {
    return this.http.post(
      this.apiUrl + '/patient/merge-visits',
      { from_id: fromId, to_id: toId },
      this.getAuthHeaders(),
    );
  }

  getPatient(params?: any) {
    let options: any = this.getAuthHeaders();
    if (params) {
      options.params = params;
    }
    return this.http.get(
      this.apiUrl + '/patient',
      options
    );
  }

  getSinglePatient(id: number) {
    return this.http.get(
      // this.common.getBaseUrl() + 'patient');
      this.apiUrl + '/patient/' + id,
      this.getAuthHeaders()
    );
  }

  getPatientsBatch(ids: number[]) {
    return this.http.post(this.apiUrl + '/patients/batch', { ids }, this.getAuthHeaders());
  }

  addPatient(payload: any) {
    // return this.http.post('/api/destinations', destination);
    // payload["action"] = "addPatient";
    // return this.http.post(this.common.getBaseUrl() + 'PRegistation.php', payload);
    return this.http.post(this.apiUrl + '/patient', payload,
      this.getAuthHeaders()
    );
  }

  updatePatient(payload: any) {
    payload["action"] = "updatePatient";
    // return this.http.put(this.common.getBaseUrl() + 'PRegistation.php', payload);
    return this.http.put(
      this.apiUrl + '/patient/' + payload.id, payload,
      this.getAuthHeaders()
    );
  }

  deletePatient(payload: any) {
    payload["action"] = "deletePatient";
    return this.http.delete(
      this.apiUrl + '/patient/' + payload.id,
      this.getAuthHeaders()
    );
  }

  toggleActive(id: number) {
    return this.http.patch(
      this.apiUrl + '/patient/' + id + '/toggle-active', {},
      this.getAuthHeaders()
    );
  }

  getCards() {
    return this.http.get(
      this.apiUrl + '/card',
      this.getAuthHeaders()
    );
  }

  getCard(id: number) {
    return this.http.get(
      this.apiUrl + '/card/' + id,
      this.getAuthHeaders()
    );
  }

  searchCards(query: string, limit = 20) {
    return this.http.get(
      this.apiUrl + '/card/search',
      {
        ...this.getAuthHeaders(),
        params: {
          q: query,
          limit: String(limit),
        },
      }
    );
  }
}
